export const speechSynth = window.speechSynthesis;

let alex = new SpeechSynthesisUtterance(`Default Text`);

export default alex;
